import { render, staticRenderFns } from "./OneStockStatusIcon.vue?vue&type=template&id=2b86d304&scoped=true&functional=true&"
var script = {}
import style0 from "./OneStockStatusIcon.vue?vue&type=style&index=0&id=2b86d304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2b86d304",
  null
  
)

export default component.exports